module.exports = __webpack_public_path__ + "static/media/icon-03.e6b02321.png";